import { createContext } from 'react';
import { IntegrationPageSectionT } from './types';

const IntegrationPageSectionContext = createContext<IntegrationPageSectionT | object>({});

export default IntegrationPageSectionContext;
